import script from "./year.vue?vue&type=script&lang=ts&setup=true"
export * from "./year.vue?vue&type=script&lang=ts&setup=true"

import "./year.vue?vue&type=style&index=0&id=13325048&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13325048"]])

export default __exports__